<ng-container *ngIf="activeModal$ | async as modal">
  <cwc-modal
    [open]="true"
    [style.--cwc-modal-max-width]="modal.modalMaxWidth"
    [showCloseBtn]="modal.showCloseBtn"
    [closeOnBdClick]="modal.closeOnBackdrop !== false"
    [overlayZIndex]="999999"
    (cwcClose)="close()"
  >
    <header slot="header" class="modal-container__header">
      <h2>{{ modal.title }}</h2>
    </header>
    <ng-container *ngTemplateOutlet="modal.content; context: modal.context"></ng-container>
  </cwc-modal>
</ng-container>
